import React from "react";

const AboutUsTeamSection = () => {
  const teamMembers = [
    {
      id: 1,
      name: "Subhash Chander Madan",
      position: "Director",
      image: "/assets/img/team/subhash.webp",
      socialLinks: {
        linkedin: "#",
        twitter: "#",
        youtube: "#",
        instagram: "#",
      },
    },
    {
      id: 2,
      name: "Deepak Madan",
      position: "Founder & Managing Director",
      image: "/assets/img/team/deepak.webp",
      socialLinks: {
        linkedin: "#",
        twitter: "#",
        youtube: "#",
        instagram: "#",
      },
    },
    {
      id: 3,
      name: "Nisha",
      position: "Branch Manager",
      image: "/assets/img/team/nisha.webp",
      socialLinks: {
        linkedin: "#",
        twitter: "#",
        youtube: "#",
        instagram: "#",
      },
    },
    {
      id: 4,
      name: "Neha Sharma",
      position: "Digital Strategist",
      image: "/assets/img/team/neha.webp",
      socialLinks: {
        linkedin: "#",
        twitter: "#",
        youtube: "#",
        instagram: "#",
      },
    },
  ];

  return (
    <div className="team2 about-page-team sp">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 m-auto text-center">
            <div className="heading1">
              <span className="span">
                <img src="/assets/img/icons/span1.png" alt="" /> Our Team
              </span>
              <h2>Meet With Our Expert Team</h2>
            </div>
          </div>
        </div>

        <div className="space30"></div>
        <div className="row">
          {teamMembers.map((member) => (
            <div key={member.id} className="col-lg-3 col-md-6">
              <div className="team-box">
                <div className="image-area">
                  <div className="image">
                    <img src={member.image} alt={member.name} />
                  </div>
                  {/* <div className="icon-area">
                    <ul>
                      <li>
                        <a href={member.socialLinks.linkedin}>
                          <i className="fa-brands fa-linkedin-in"></i>
                        </a>
                      </li>
                      <li>
                        <a href={member.socialLinks.twitter}>
                          <i className="fa-brands fa-x-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href={member.socialLinks.youtube}>
                          <i className="fa-brands fa-youtube"></i>
                        </a>
                      </li>
                      <li>
                        <a href={member.socialLinks.instagram}>
                          <i className="fa-brands fa-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div> */}
                </div>

                <div className="space30"></div>
                <div className="heading1">
                  <h4>
                    <a href={`#${member.name.toLowerCase().replace(/\s+/g, '-')}`}>{member.name}</a>
                  </h4>
                  <div className="space10"></div>
                  <p>{member.position}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutUsTeamSection;
